module.exports = __webpack_public_path__ + "media/maleon-banner.9be8a398.mp4";